import * as React from 'react';
import { Input, type InputProps } from 'react-aria-components';
import { inputClasses } from './styles';

interface _InputProps extends InputProps {}

/**
 * The Input component is used to create an input field.
 *
 * @param props - The props for the Input component.
 * @example
 * <Input />
 */
const _Input = React.forwardRef((props: InputProps, ref: React.Ref<HTMLInputElement>) => {
  const { className, ...other } = props;

  return <Input ref={ref} className={inputClasses({ className })} {...other} />;
});

export { _Input as Input };
export type { _InputProps as InputProps };
